type RoutesMapping = {
    ChooseMethod: string;
    ConfirmCode: string;
    Continue: string;
    DocumentLocked: string;
    SessionExpired: string;
    Error: string;
    StartWorkflow: string;
    Home: string;
    CheckDigits: string;
};

export const routes: RoutesMapping = {
    StartWorkflow: "/App/Callback",
    Home: "/Home",
    ConfirmCode: "/ConfirmCode",
    Continue: "/Continue",
    DocumentLocked: "/DocumentLocked",
    SessionExpired: "/SessionExpired",
    Error: "/Error",
    ChooseMethod: "/ChooseMethod",
    CheckDigits: "/CheckDigits",
};
